interface AngleSetBuildInput {
  setId: number;
  brandId: number;
  originProjectId?: number | null;
  destinationProjectId?: number;
  activeProjectId: number | null;
  activeBrandId: number | null;
  set: { id: number; brandId: number; productId: number; projectId?: number | null };
  angles: Array<{ id: number; brandId: number; status: string }>;
}
type BuildContext = { uiAction: 'build_campaign'; forcedTool: { name: string; arguments: Record<string, unknown> } };

/** Dispatch the saved sheet directly, never reinterpret Build as a new brief. */
export async function dispatchAngleSetBuild(
  input: AngleSetBuildInput,
  send: (message: string, preMsgId?: string, context?: BuildContext) => Promise<void>,
): Promise<void> {
  const { set, originProjectId } = input;
  if (input.destinationProjectId !== undefined) {
    if (!Number.isSafeInteger(input.destinationProjectId) || input.destinationProjectId <= 0
      || input.destinationProjectId !== input.activeProjectId) {
      throw new Error('Open the selected destination task before building.');
    }
  } else if (!Number.isSafeInteger(originProjectId) || !originProjectId || originProjectId !== input.activeProjectId
    || (set.projectId != null && set.projectId !== originProjectId)) {
    throw new Error('Open this angle set in its original task before building.');
  }
  if (set.id !== input.setId || set.brandId !== input.brandId || set.brandId !== input.activeBrandId
    || !Number.isSafeInteger(set.productId) || set.productId <= 0) {
    throw new Error('This angle set does not match the task’s brand and product. Reopen the original task.');
  }
  const angles = input.angles.filter(a => a.status === 'approved' || a.status === 'edited');
  if (!angles.length || angles.some(a => a.brandId !== set.brandId || !Number.isSafeInteger(a.id) || a.id <= 0)) {
    throw new Error('This set has no valid approved angles to build. Reload the set and try again.');
  }
  const angleIds = Array.from(new Set(angles.map(a => a.id)));
  await send(`Build ${angleIds.length} ads from this brief`, undefined, {
    uiAction: 'build_campaign',
    forcedTool: { name: 'run_angles_to_campaign', arguments: { setId: set.id, angleIds, productId: set.productId } },
  });
}
